import 'vite/modulepreload-polyfill'; // Import modulepreload-polyfill to ensure compatibility with older browsers
import 'lazysizes';
import loadModules from './utils/module-loader'; // Custom module loader
import config from '../../config/theme-config.json' assert { type: 'json' };

const relaxBreakpoints = [
  parseInt(config.breakpoints.sm.replace('px', ''), 10), // xs
  parseInt(config.breakpoints.md.replace('px', ''), 10), // mobile
  parseInt(config.breakpoints.lg.replace('px', ''), 10) // tablet
];

// Base
import { initNavigation, initNavColorContrast, headerScrollHandler } from './inc/nav.js'
import { initCursor, destroyCursor } from './inc/custom-cursor.js';

// Animations
import { fadeInElements } from './inc/fadein.js';

// Verplaatsen
import Rellax from 'rellax'

import.meta.glob([
  '../images/**',
  '../fonts/**',
  //'!**/*.js',
  //'!**/*.scss',
]);

// Custom
// import {menu} from "../modules/menu";
// import {lazy} from "../modules/lazy";
// import {gallery} from "../modules/gallery";
// import {accordions} from "../modules/accordions";
// import {adminbar} from "../modules/menu/adminbar";

// Main 

// Dynamically load slider.js only when the slider component is present
document.addEventListener('DOMContentLoaded', () => {

  // Verplaatsen
  var rellax = new Rellax(
  '.parallax', {
    center: false,
    //percentage: 0.5
  });

  var rellax_cards = new Rellax(
    '.rellax', {
      breakpoints: relaxBreakpoints,
      center: true,
      percentage: 0.3 // start effect eerder, lager in het scherm
      //
  });

  // Helper voor lazy background images (lazysizes)
  document.addEventListener("lazybeforeunveil", function(e) {
    let bg = e.target.getAttribute("data-bg");
    if (bg) {
        e.target.style.backgroundImage = "url('" + bg + "')";
    }
  });

  document.querySelector("main").classList.add("visible");

  // const test = document.querySelector('.main-header');
  // test.addEventListener('click', () => console.log("🔥 Click op .main-header!"));

  initScripts();

  // document.addEventListener('click', (event) => {
  //   console.log("✅ Echte klik gedetecteerd op:", event.target);  
  // });

  //test.addEventListener('click', console.log("🔥 Click op .container!")); // Oeps, direct uitgevoerd!

  // Base
  // const mobileNavElement = document.querySelector('.navigation--mobile');;
  // initNavigation(mobileNavElement);
  
});

function initScripts() {
  initNavigation();
  initNavColorContrast();
  headerScrollHandler();

  initCursor();
  // Component blocks
  loadModules();
  fadeInElements();
}

export function reInitScripts() {
  console.log('reInitScripts');
  //initScripts(); // not all
  initNavigation();
  initNavColorContrast();
  headerScrollHandler();

  initCursor();
  loadModules();
  fadeInElements();
}


// If Barba
if ( config.features.barba ) {
  document.addEventListener("DOMContentLoaded", function () {
    //console.log('🚀 DOM geladen, Barba.js wordt geïnitialiseerd');

    if (!document.querySelector('[data-barba="wrapper"]')) {
        console.error('❌ Barba.js kan geen wrapper vinden');
        return;
    }
    
  });
}

// If Swup
if ( config.features.swup ) {
  document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector('#main')) {
        console.error('❌ Swup.js kan geen wrapper vinden');
        return;
    }
  });
}

// Front-end editor
// document.addEventListener('DOMContentLoaded', function () {
//   const editorContainer = document.getElementById('acf-editor-container');
//   const openEditorBtn = document.getElementById('open-acf-editor');
//   const acfForm = document.querySelector('.acf-form');

//   if (!editorContainer || !openEditorBtn || !acfForm) return;

//   // Editor tonen bij klikken op de bewerk-knop
//   openEditorBtn.addEventListener('click', function () {
//       editorContainer.classList.remove('hidden');
//   });

//   // AJAX-functionaliteit voor ACF formulier
//   acfForm.addEventListener('submit', function (e) {
//       e.preventDefault();

//       let formData = new FormData(acfForm);

//       fetch(window.location.href, {
//           method: 'POST',
//           body: formData,
//       })
//       .then(response => response.json())
//       .then(data => {
//           if (data.success) {
//               editorContainer.classList.add('hidden'); // Verberg editor
//               location.reload(); // 🔥 Hier kun je nog een slimmere DOM-update maken i.p.v. reload
//           } else {
//               alert('Opslaan mislukt!');
//           }
//       });
//   });
// });


// ✅ Fix voor Vite HMR
// if (import.meta.hot) {
//   console.log("🔥 Vite HMR actief, event listeners resetten...");
//   import.meta.hot.dispose(() => {
//       console.log("♻️ Event listener verwijderen vóór herladen");
//       document.removeEventListener('click', handleMenuToggle);
//   });
// }


// Front end modaal test
// KEEP
// AcfModalEditor.js (voorbeeld)
// Plaats het in je eigen script en zorg dat jQuery en ACFE geladen zijn.
// (function($){
//   $(function(){

//     $('.editable-component').on('click', function(e){
//       e.preventDefault();

//       // Haal row-index op (in je foreach gebruik je b.v. data-row-index="{{ $index }}")
//       const rowIndex = $(this).data('row-index'); // "2", "3", etc.

//       // Vind de layout in de hidden ACF form, b.v. data-id="row-2"
//       const $layout = $(`.layout[data-id="row-${rowIndex}"]`);

//       if (!$layout.length) {
//         console.warn('Geen ACFE layout gevonden voor row:', rowIndex);
//         return;
//       }

//       // Vind de ACFE "edit" trigger, die normaliter ook in de DOM staat. 
//       // Let op: kan op de handle of de placeholder zitten, 
//       // vaak: .acfe-fc-placeholder[data-action="acfe-flexible-modal-edit"]
//       const $editTrigger = $layout.find('[data-action="acfe-flexible-modal-edit"]');

//       if (!$editTrigger.length) {
//         console.warn('Geen ACFE edit-trigger gevonden in layout row:', rowIndex);
//         return;
//       }

//       // Simuleer de klik, zodat ACFE zijn modal opent
//       $editTrigger.trigger('click');

//     });

//   });
// })(jQuery);

